export default __webpack_public_path__ + "static/media/IF_MySalesStyle_Big.59b1f9d0.jpg";